import type { JobCardData, SuggestedAction } from '../types';

// Statuses from which publishing is actionable. Everything else — published,
// open (nexus job_status), live/unlisted (listing_status), closed, archived —
// rejects or no-ops a publish, so the chip is hidden. Allowlist (not a
// blocklist) so an unknown/new status fails safe by hiding the chip.
const PUBLISHABLE_STATUSES = new Set([
  'draft',
  'pending_approval',
  'rejected',
  'scheduled',
  '',
]);

/** Selection entries that don't belong to THIS list are stale leftovers from
 *  another block sharing the storage bucket — they must not steer chips. */
export const resolveJobSelection = (
  selection: string[] | undefined,
  jobs: JobCardData[]
): string[] => {
  const own = new Set(jobs.map((j) => j.id));
  return (selection ?? []).filter((id) => own.has(id));
};

/** CORE-4840: hide status-inapplicable actions, judged against the job the
 *  action will actually target ({first_id} = first selected, else top row). */
export const gateJobActions = (
  actions: SuggestedAction[] | undefined,
  targetJob: JobCardData | undefined
): SuggestedAction[] => {
  const status = (targetJob?.status ?? '').toLowerCase();
  return (actions ?? []).filter(
    (a) =>
      !(a.label === 'Publish job post' && !PUBLISHABLE_STATUSES.has(status))
  );
};
